
import { mapActions, mapGetters } from 'vuex'
import { capitalize } from '@/utils/StringUtils'
import { clone } from '@/utils/enerFunctions'

export default {
  name: 'BenchmarkBuilder',
  computed: {
    ...mapGetters({
      regions: 'regions',
      benchmarkRegions: 'page/benchmarkRegions'
    }),
    sortedRegions () {
      const orderedRegions = clone(this.regions)
      return orderedRegions.sort((a, b) => (a[this.textField] > b[this.textField]) ? 1 : ((b[this.textField] > a[this.textField]) ? -1 : 0))
    },
    textField () {
      return 'name' + capitalize(this.$i18n.locale)
    }
  },
  methods: {
    ...mapActions({
      setBenchmarkRegions: 'page/setBenchmarkRegions',
      clearBenchmarkRegions: 'page/clearBenchmarkRegions',
      removeBenchmarkRegion: 'page/removeBenchmarkRegion'
    })
  }
}
